import DeleteDraftModal from "./DeleteDraftModal";

export default DeleteDraftModal;
